import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  baseCustomerDashboardEffects,
  baseCustomerDashboardReducer,
  basePspDashboardEffects,
  basePspDashboardReducer,
} from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('pspDashboard', basePspDashboardReducer.BasePspDashboardReducer),
    StoreModule.forFeature('customerDashboard', baseCustomerDashboardReducer.BaseCustomerDashboardReducer),
    EffectsModule.forFeature([
      basePspDashboardEffects.BasePspDashboardEffects,
      baseCustomerDashboardEffects.BaseCustomerDashboardEffects,
    ]),
  ],
})
export class BaseDashboardStoreModule {}
